
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BookingsActions, ModulesSelectors, NotificationsActions, NotificationsSelectors, UserNotification, AccountSelectors, LocalStorageService, LocalizationSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'serviceos-web-notifications-list',
    templateUrl: './notifications-list.component.html',
	animations: [],
    styleUrls: ['./notifications-list.component.scss'],
})
export class NotificationsListComponent implements OnInit, OnDestroy, OnChanges {
	
	@Select(NotificationsSelectors.getAll)
    public notifications$!: Observable<UserNotification[] | null>;

	@Select(NotificationsSelectors.getAllUnclosed)
    public unclosedNotifications$!: Observable<UserNotification[] | null>;

	@Select(ModulesSelectors.getImageFromModule('account', 'missing_notifications_img'))
    missingNotificationsImg$!: Observable<string>;

	@Select(ModulesSelectors.getComponentFromModule('account', 'notifications'))
    notificationsComponentConfig$!: Observable<any>;

	@Select(ModulesSelectors.getModuleConfigText('customer'))
    moduleCustomerTexts$!: Observable<any>;

	@Input()
	public isMainPage = false;

	@Input()
	public limit = 99;

	@Output()
	public notificationClicked = new EventEmitter<UserNotification>();

	public requestInProgress = false;

	public userData: any = null;

	public texts: any = null;

	private userPastBookings: any = null;

	public showLocalLoader = false;
	public documentDirection = '';

    constructor(
		private store: Store,
		private cdr: ChangeDetectorRef,
		private _localStorageService: LocalStorageService,
		private router: Router
		) {}

    ngOnInit(): void {

		this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )

		const accountModuleConfig = this.store.selectSnapshot(ModulesSelectors.getModuleByName('account'));
		this.texts = accountModuleConfig?.texts;

		this.requestInProgress = true;
		const params = {
            expand: 'all',
            // 'paging[limit]': 6
        };
		this.store.dispatch(new BookingsActions.GetAll(true, params))
			.pipe(
				finalize(() => {
					this.store.dispatch(new NotificationsActions.GetAll())
					this.requestInProgress = false;
				})
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		const counterElements: NodeList =  document.querySelectorAll('.notifications-counter.visible');

		// Remove counter elements from DOM - temporary decision!!!
		if (counterElements && counterElements.length) {
			counterElements.forEach((elem: any) => {
				elem.remove();
			});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		//! TODO this is temporary decision! fix this when whole app is on angular
		if (changes && changes.notifications && !changes.notifications.firstChange) {
			const counterElements: NodeList =  document.querySelectorAll('.notifications-counter.visible'),
				newNotificationsLength: number = changes.notifications.currentValue.length;

			if (counterElements && counterElements.length) {
				counterElements.forEach((elem: any) => {
					// update counter value
					elem.innerText =  newNotificationsLength;
				});
			}
		}
	}

	/**
	 * Handler for click on notification
	 * @param notification 
	 */
	public onNotificationClick(notification: UserNotification): void {
		this.notificationClicked.emit(notification);
	}

	public closeAllNotifications() {

		this.showLocalLoader = true;

		
		setTimeout(()=> {
			const allNotifications = this.store.selectSnapshot(NotificationsSelectors.getAll);

			if (allNotifications && allNotifications.length) {
				allNotifications.forEach((item) => {
					this.onNotificationClose(item);
				})
			}

			this.showLocalLoader = false;
		}, 1000);
	}

	/**
	 * Close click handler
	 * @param notification
	 */
	public onNotificationClose(notification: UserNotification): void {

		const userData = this.store.selectSnapshot(AccountSelectors.account);

		const requestObject: any = {
			id: notification.id,
            messageType: notification.messageType,
            // _token: (window as any).csrfToken,
            url: notification.url,
        };

        if (notification.messageType === 'bookings_unrated_notice')
            Object.assign(requestObject, { objectId: notification?.objectId });

			this.requestInProgress = true;

		this._localStorageService.setItem(requestObject?.objectId ? userData?.id + '_' + requestObject.messageType + '_' + requestObject.objectId : userData?.id + '_' + requestObject.messageType, 1 );

        this.store
            .dispatch(new NotificationsActions.Remove(requestObject))
            .pipe(
                finalize(() => {
                    this.requestInProgress = false;
					this.cdr.detectChanges();
                })
            )
            .subscribe();

	}

	/**
     * Navigate to path
     * @param {string} path
     */
    navigateTo(path: string) {
        // skip navigate if you are on the same path
        if (this.router.url.indexOf(path) === -1) {
            this.router.navigateByUrl(path);
        }
    }

	hasUnclosedNotification() {
		const allNotifications = this.store.selectSnapshot(NotificationsSelectors.getAll);
		return !! allNotifications && allNotifications.filter((item)=> !item.closed);
	}
}
